import { render, staticRenderFns } from "./cryptoDeposit.vue?vue&type=template&id=2e2cf252&scoped=true"
import script from "./cryptoDeposit.vue?vue&type=script&lang=js"
export * from "./cryptoDeposit.vue?vue&type=script&lang=js"
import style0 from "./cryptoDeposit.vue?vue&type=style&index=0&id=2e2cf252&prod&lang=scss"
import style1 from "./cryptoDeposit.vue?vue&type=style&index=1&id=2e2cf252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2cf252",
  null
  
)

export default component.exports